import {Component, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Component({
    selector: 'app-paystack',
    templateUrl: './paystack.component.html',
    styleUrls: ['./paystack.component.scss']
})
export class PaystackComponent implements OnInit {
    paymentSuccess: boolean;
    constructor(private http: HttpClient) {
    }

    ngOnInit() {
    }

}
